import React from "react";
import { Box, TextField, Typography, Divider, Stack } from "@mui/material";

export default function PositionPanel({ el, updateEl }) {
    return (
        <Stack spacing={1} mt={1.5}>
            <Divider />
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                Position &amp; Taille
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
                {[["X", "x"], ["Y", "y"], ["Largeur", "width"], ["Hauteur", "height"]].map(([label, key]) => (
                    <TextField
                        key={key}
                        label={label}
                        type="number"
                        size="small"
                        value={Math.round(el[key])}
                        onChange={e => updateEl(el.id, { [key]: Number(e.target.value) })}
                    />
                ))}
            </Box>
        </Stack>
    );
}
